import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {setPrimaryEmailMutationType} from "./__graphql-types__/index.ts";

export const SET_PRIMARY_EMAIL_MUTATION: GqlOperation<
    setPrimaryEmailMutationType["response"],
    setPrimaryEmailMutationType["variables"]
> = gqlOp(gql`
    mutation setPrimaryEmailMutation($email: String!) {
        setPrimaryEmail(email: $email) {
            error {
                code
            }
        }
    }
`);
